import { InvalidUrlError } from '@execonline-inc/url';
import { HttpError } from 'ajaxian';
import {
  AppyError,
  MissingApiCompatibility,
  MissingApplicationId,
} from '../../../../../../../Appy';
import { MissingLinkError } from '../../../../../../../LinkyLinky';
import { Resource, ValidationError } from '../../../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../../../Translations';
import { License } from '../../../Stores/ShareStore/Types';

export interface SearchOptions {
  licenses: ReadonlyArray<License>;
}

export type SearchOptionsResource = Resource<SearchOptions>;

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  searchOptionsResource: SearchOptionsResource;
}

export interface Error {
  kind: 'error';
  message: TPlainTextKey;
}

export type SearchOptionsState = Waiting | Loading | Ready | Error;

export type SearchOptionsError =
  | HttpError
  | MissingLinkError
  | MissingApplicationId
  | MissingApiCompatibility
  | AppyError
  | Error
  | ValidationError
  | InvalidUrlError;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (searchOptionsResource: SearchOptionsResource): Ready => ({
  kind: 'ready',
  searchOptionsResource,
});
